import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaRocket,
  FaEye,
  FaStar,
  FaMobileAlt,
  FaBriefcase,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MotionGraphicsVideoProductionInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Motion Graphics Video Production in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Motion Graphics Video Production</span>{" "}
            in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver expert motion graphics video
            production in **DIFC**, creating visually stunning and engaging
            videos that captivate audiences and elevate your brand. Bring your
            story to life with our creative expertise.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1633613286991-611fe299c4be?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Motion graphics work
          "https://images.unsplash.com/photo-1581472723648-909f4851d4ae?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Design team working
          "https://images.unsplash.com/photo-1535016120720-40c646be5580?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Digital animation visuals
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Video Production in DIFC"
        description="We craft motion graphics videos with creativity and precision."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Creative Expertise",
            description: "Innovative designs by experienced professionals.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Videos that connect and resonate with audiences.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Stunning Visuals",
            description: "High-quality graphics that capture attention.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Timely production without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for web, mobile, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred by businesses for professional videos.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Production Process"
        description={
          <Description>
            We create motion graphics videos with a streamlined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your brand and vision.</li>
              <li>Storyboarding: Plan engaging narratives and visuals.</li>
              <li>Design: Craft stunning motion graphics.</li>
              <li>Production: Animate with precision and creativity.</li>
              <li>Review: Ensure alignment with your goals.</li>
              <li>Delivery: Provide polished videos ready for impact.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744094-3a31f272c490?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Professional planning
          "https://images.unsplash.com/photo-1617503752587-97d2103a96ea?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Animation workspace
          "https://images.unsplash.com/photo-1599420186946-7b6fb4e297f0?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Digital creative process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Professional Wins in DIFC"
        description="Our videos have transformed brand narratives."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Tripled views with compelling motion graphics.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description:
              "Boosted recognition*Note: This is a hypothetical example for illustrative purposes. Always ensure you have the rights to use images or create original content to avoid copyright issues increased brand recognition for a DIFC client.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval rate from DIFC businesses.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Videos?</Subheading>}
        heading="Motion Graphics in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for professional motion graphics video
            production in DIFC. Get captivating, high-impact videos that reflect
            your brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1565728744382-61accd4aa148?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Creative team collaboration
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Digital graphics work
          "https://images.unsplash.com/photo-1624696941338-401aea7eec94?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000", // Professional video setup
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
